(() => {
  const configNode = document.getElementById('pro-catalog-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (config.enabled !== true) return;
  const selector = '[data-pro-catalog-handle]';
  const externalCards = '.vsly-product-block, .ns-product';
  const cache = new Map();
  const pending = new WeakMap();
  const root = String(config.root || '/').replace(/\/?$/, '/');
  let frame;

  function prices(handle) {
    if (!cache.has(handle)) {

      cache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=cust-pro-price`, { cache: 'no-store', headers: { Accept: 'text/html' } })
        .then(response => {
          if (!response.ok) throw new Error('PRO product price request failed');
          return response.json();
        })
        .then(data => {
          if (typeof data.eligible !== 'boolean' || !Array.isArray(data.variants)) throw new Error('Invalid PRO product prices');
          return data;
        })
        .catch(error => {
          cache.delete(handle);
          throw error;
        }));
    }
    return cache.get(handle);
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function createOutput(element) {
    let output = element.querySelector('[data-pro-catalog-output]');
    if (output) return output;
    output = document.createElement('span');
    output.className = 'cust-pro-card-price';
    output.setAttribute('data-pro-catalog-output', '');
    const amount = document.createElement('span');
    amount.setAttribute('data-pro-catalog-amount', '');
    const retail = document.createElement('s');
    retail.setAttribute('data-pro-catalog-retail', '');
    const label = document.createElement('span');
    label.className = 'cust-pro-card-regular-label';
    label.setAttribute('data-pro-catalog-regular-label', '');
    label.textContent = 'Regular price';
    label.hidden = true;
    output.append(amount, retail, label);
    element.append(output);
    return output;
  }

  async function render(element) {
    const handle = element.dataset.proCatalogHandle;
    if (!handle) return;
    const server = element.hasAttribute('data-pro-card-price') || element.hasAttribute('data-pro-regular-card');
    const variantId = server ? element.closest('product-card')?.dataset.variantId || element.dataset.proCatalogVariant : element.getAttribute('data-variant-id') || element.dataset.proCatalogVariant;
    const subscription = element.dataset.proCatalogSubscription === 'true';
    const key = `${handle}:${variantId || ''}:${subscription}`;
    if (subscription) {
      pending.set(element, { key });
      element.removeAttribute('data-pro-catalog-active');
      element.querySelector('[data-pro-catalog-output]')?.remove();
      return;
    }
    if (server && String(variantId) === element.dataset.proCatalogVariant) {
      pending.set(element, { key });
      return;
    }
    const previous = pending.get(element);
    if (previous?.key === key && (previous.loading || (!server && element.querySelector('[data-pro-catalog-output]')))) return;
    const state = { key, loading: true };
    pending.set(element, state);
    if (!server && previous?.key !== key) {
      element.removeAttribute('data-pro-catalog-active');
      element.querySelector('[data-pro-catalog-output]')?.remove();
    }
    try {
      const data = await prices(handle);
      if (!element.isConnected || pending.get(element) !== state) return;
      const variant = variantId ? data.variants.find(item => String(item.id) === String(variantId)) : data.variants[0];
      if (!variant || typeof variant.pro !== 'string' || typeof variant.retail !== 'string') return;
      const output = server ? element : createOutput(element);
      setText(output.querySelector('[data-pro-catalog-amount]'), data.eligible ? variant.pro : (variant.regular || variant.retail));
      const retail = output.querySelector('[data-pro-catalog-retail]');
      const label = output.querySelector('[data-pro-catalog-regular-label]');
      setText(retail, data.eligible ? variant.retail : '');
      if (retail) retail.hidden = !data.eligible;
      if (label) label.hidden = data.eligible;
      output.classList.toggle('cust-pro-card-price--regular', !data.eligible);
      if (server && element.hasAttribute('data-pro-regular-card')) {
        const unit = element.nextElementSibling;
        if (unit?.hasAttribute('data-pro-unit-price')) {
          unit.classList.toggle('hidden', !variant.unit);
          setText(unit.querySelector('[data-pro-unit-amount]'), variant.unit?.amount || '');
          setText(unit.querySelector('[data-pro-unit-reference]'), variant.unit?.reference || '');
        }
      }
      if (server) element.dataset.proCatalogVariant = String(variant.id);
      else element.setAttribute('data-pro-catalog-active', '');
    } catch (error) {

      console.error('PRO catalog price refresh failed:', error);
    } finally {
      state.loading = false;
    }
  }

  function prepareExternalCards() {
    document.querySelectorAll(externalCards).forEach(card => {
      const nostoPrice = card.querySelector('.ns-price');
      const price = card.querySelector('.vsly-product-prices-section, .ns-price-wrap') || nostoPrice?.parentElement;
      const link = card.querySelector('a[href*="/products/"]');
      if (!price || (!link && !card.dataset.handle)) return;
      try {
        const url = new URL(link?.getAttribute('href') || `${root}products/${encodeURIComponent(card.dataset.handle)}`, window.location.href);
        const match = url.pathname.match(/\/products\/([^/]+)/);
        const handle = card.dataset.handle || (match && decodeURIComponent(match[1]));
        if (!handle) return;
        const variant = price.getAttribute('data-variant-id') || price.querySelector('[data-variant-id]')?.getAttribute('data-variant-id') || card.dataset.variantId || url.searchParams.get('variant') || '';
        if (price.dataset.proCatalogHandle !== handle) price.dataset.proCatalogHandle = handle;
        if (price.dataset.proCatalogVariant !== variant) price.dataset.proCatalogVariant = variant;
      } catch {}
    });
  }

  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      prepareExternalCards();
      document.querySelectorAll(selector).forEach(render);
    });
  };
  const relevant = node => node.nodeType === 1 && !node.closest('[data-pro-catalog-output]') &&
    (node.matches(selector) || node.matches('product-card') || node.closest(externalCards) || node.querySelector(`${selector}, ${externalCards}`));
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' ? relevant(record.target) :
      [...record.addedNodes].some(relevant) || (record.target.matches?.(selector) && [...record.removedNodes].some(node => node.nodeType === 1)))) schedule();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true,
    attributeFilter: ['href', 'data-handle', 'data-variant-id', 'data-pro-catalog-handle', 'data-pro-catalog-variant', 'data-pro-catalog-subscription'] });
  ['rebuy.ready', 'rebuy.productsChange', 'rebuy.selectedVariantChange', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('change', event => {
    const card = event.target.closest?.('.wndrsxn__product-card');
    const price = card?.querySelector(selector);
    if (price && event.target.matches('select')) price.dataset.proCatalogVariant = event.target.value;
  });
  schedule();
})();
